import { render } from "./Login.vue?vue&type=template&id=1fcd5f89"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=1fcd5f89&lang=scss"
script.render = render

export default script